import { AlertCircle } from "lucide-react"

export function NotFoundPage() {
    return (
        <div className="flex flex-col items-center justify-center h-screen text-center">
            <AlertCircle className="w-24 h-24 text-red-500 mb-4" />
            <h1 className="text-4xl font-bold mb-2">404 - Page Not Found</h1>
            <p className="text-lg text-gray-600">The page you are looking for does not exist.</p>
        </div>
    )
}
